import Image from 'next/image';
import { ReactNode } from 'react';

export function AiText({ children }: { children: ReactNode }) {
  return (
    <span className="bg-[linear-gradient(#eee_-20%,#ed630f_100%)] bg-clip-text font-bold text-transparent">
      {children}
    </span>
  );
}

export function CheckItem({ children }: { children: ReactNode }) {
  return (
    <li className="flex w-full items-center gap-2">
      <svg
        aria-hidden="true"
        className="text-orange h-4 w-4 shrink-0"
        fill="none"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 8.2L6.2 11.4L13 4.6"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
      <p className="w-full">{children}</p>
    </li>
  );
}

export function StoreBadgeLink({ alt, href, src }: { alt: string; href: string; src: string }) {
  return (
    <a href={href} rel="noreferrer" target="_blank">
      <Image
        alt={alt}
        className="mr-3 mb-3 h-auto max-w-40 w-auto cursor-pointer transition-opacity duration-150 hover:opacity-30"
        height={48}
        src={src}
        width={160}
      />
    </a>
  );
}
